'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { RICH_TEXT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, ENABLED_FEATURES } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { makeGetModulePath } from 'DesignData/selectors/customWidgetBuffers';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import RichTextWithConfigLoader from 'DesignEditorsUI/components/shared/RichTextWithConfigLoader';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

const mapStateToProps = (state, props) => {
  const getModulePath = makeGetModulePath();
  return {
    modulePath: getModulePath(state, props)
  };
};

class RichTextContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  render() {
    const {
      field,
      fieldErrors,
      modulePath,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(FormControlWithErrors, {
      errors: fieldErrors[DEFAULT],
      label: I18n.text(i18nKey(`defaultLabels.${RICH_TEXT}`)),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        enabled_features: field[ENABLED_FEATURES],
        id: field.id,
        inputComponent: RichTextWithConfigLoader,
        modulePath: modulePath,
        onFieldChange: this.onDefaultChange,
        readOnly: readOnly,
        shouldFetchCustomFonts: true,
        value: field[DEFAULT]
      })
    });
  }

}

RichTextContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  modulePath: PropTypes.string.isRequired,
  readOnly: PropTypes.bool
};
RichTextContentOptions.defaultProps = {
  fieldErrors: {}
};
export default connect(mapStateToProps)(RichTextContentOptions);